<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->

          <!-- Search -->
          <b-col cols="12" lg="8">
            <b-row class="align-items-center">
              <b-col lg="6" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    @keyup.enter="onSearch()"
                    v-model.trim="searchQuery"
                    class="d-inline-block round"
                    :placeholder="$t('Enter name, code')"
                  />
                </div>
              </b-col>
              <b-col
                cols="12"
                md="4"
                lg="4"
                class="d-flex align-items-center justify-content-center justify-content-lg-start p-0 my-1 m-lg-0"
              >
                <b-button
                  class="round px-5"
                  variant="primary"
                  @click="onSearch"
                >
                  {{ $t("search") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <b-table
        responsive="sm"
        :items="itemsFilter"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
      </b-table>
      <b-row class="pl-2 pr-2 pb-1 pt-1 border-top">
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t("showing") }}</label>

          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            style="min-width: 60px"
            class="per-page-selector select-size-sm d-inline-block ml-50 mr-1"
          />
          <label>{{ $t("entries") }}</label>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
  
  <script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

import vSelect from "vue-select";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  mounted() {
    this.fetchItems();
  },
  watch: {
    searchQuery: function (newVal, oldVal) {
      if (newVal == "") {
        this.itemsFilter = [...this.items];
        this.totalRows = this.itemsFilter.length;
      }
    },

    "$i18n.locale": function (newVal, oldVal) {
      this.renderComponent = false;
      this.fields = [];
      this.$nextTick(() => {
        // Add the component back in
        this.fields = [
          {
            key: "code",
            sortable: false,
            label: "code",
          },
          {
            key: "name",
            sortable: false,
            label: "name",
            label: this.$i18n.t("name"),
          },
          {
            key: "customs_department",
            label: this.$i18n.t("customs_department"),
            sortable: false,
          },
          {
            key: "description",
            label: this.$i18n.t("description"),
            sortable: false,
          },
        ];

        this.renderComponent = true;
      });
    },
  },
  computed: {},
  methods: {
    onSearch() {
      this.$loading.show();
      if (this.searchQuery != "") {
        const searchData = [...this.items];
        this.itemsFilter = searchData.filter((item) => {
          return (
            item.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
            item.code.toLowerCase().includes(this.searchQuery.toLowerCase())
          );
        });
        this.currentPage = 1;
        this.totalRows = this.itemsFilter.length;
      } else {
        this.itemsFilter = [...this.items];
        this.currentPage = 1;
        this.totalRows = this.itemsFilter.length;
      }
      this.$loading.hide();
    },
    fetchPermission: function () {
      this.permisItems = [];
      useJwt
        .get(`groupPermission/${this.currentItem.ID}`, {})
        .then((response) => {
          this.permisItems = response.data.result;
          this.permisItems.forEach(function (i, v) {
            i.C = i.C == 1 ? true : false;
            i.R = i.R == 1 ? true : false;
            i.U = i.U == 1 ? true : false;
            i.D = i.D == 1 ? true : false;
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title:
                "Lỗi lấy danh sách quyền theo nhóm " +
                this.currentItem.ROLE_NAME,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    fetchItems: function () {
      useJwt
        .get("masterData?data=CustomsSubDept", {
          params: {
            search: this.searchQuery,
            page: this.currentPage,
            pageSize: this.perPage,
          },
        })
        .then((response) => {
          this.items = response.data.result;
          this.itemsFilter = [...this.items];
          this.totalRows = response.data.meta.total;
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
  },
  data() {
    return {
      items: [],
      itemsFilter: [],
      permisItems: [],
      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      searchQuery: "",
      currentItem: {},
      modal_title: "Add Permission",
      fields: [
        {
          key: "code",
          sortable: false,
          label: "code",
        },
        {
          key: "name",
          sortable: false,
          label: "name",
          label: this.$i18n.t("name"),
        },
        {
          key: "customs_department",
          label: this.$i18n.t("customs_department"),
          sortable: false,
        },
        {
          key: "description",
          label: this.$i18n.t("description"),
          sortable: false,
        },
      ],
    };
  },
};
</script>
  <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>